import { Field } from 'api/tasks';
import { unreachable } from 'utils/unreachable';
import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from '../filters/estimate';
import { getFieldValue } from './get-field-value';
import { FilterFunction } from '.';

export const estimate = (filter: EstimateFieldFilter): FilterFunction => {
  const value = getFieldValue<number | string>(filter.field as any as Field);

  /* Estimate field type is not an actual custom field type. In future if its needed, please handle the following conditions accordingly. */

  switch (filter.type) {
    case EstimateFieldFilterOperationType.IsMoreThan:
      return (record) => {
        const recordValue = value(record);

        if (
          filter.days == null ||
          filter.direction == null ||
          recordValue == null
        ) {
          return false;
        }
        switch (filter.direction) {
          case EstimateRelativeDirection.Early:
            return (
              recordValue > 0 && Math.abs(recordValue as number) > filter.days
            );
          case EstimateRelativeDirection.Late:
            return (
              recordValue < 0 && Math.abs(recordValue as number) > filter.days
            );
          default:
            return unreachable(filter.direction);
        }
      };
    case EstimateFieldFilterOperationType.IsLessThan:
      return (record) => {
        const recordValue = value(record);

        if (
          filter.days == null ||
          filter.direction == null ||
          recordValue == null
        ) {
          return false;
        }
        switch (filter.direction) {
          case EstimateRelativeDirection.Early:
            return (
              recordValue > 0 && Math.abs(recordValue as number) < filter.days
            );
          case EstimateRelativeDirection.Late:
            return (
              recordValue < 0 && Math.abs(recordValue as number) < filter.days
            );
          default:
            return unreachable(filter.direction);
        }
      };
    default:
      return unreachable(filter);
  }
};
